import PageBuilder from '../../pageBuilder/PageBuilder';
import EventHasVarieties from '../eventHasVarieties/EventHasVarieties';

export default {
  // component name (used for Imports)
  name: 'EventDetails',

  // import data from parent
  inject: [
    'eventsData',
    'storageData',
    'saveStorageData',
    'addToCart',
    'getEventByUuid',
    'promises'
  ],

  // import components
  components: {
    'page-builder': PageBuilder,
    'event-has-varieties': EventHasVarieties
  },

  data () {
    return {
      currentEvent: null,
      eventUuid: '',
      varieties: {},
      availability: ''
    };
  },

  // function definitions
  methods: {
    checkAvailability: function () {
      let takenSeats = this.currentEvent.maximumSeatAmount - this.currentEvent.availableSeatAmount;
      let filledSeatsInPercent = 100 / this.currentEvent.maximumSeatAmount * takenSeats;
      this.availability = 'good';
      if (filledSeatsInPercent > this.currentEvent.availabilityBreakpoint) {
        this.availability = 'medium';
      }
      if (filledSeatsInPercent === 100) {
        this.availability = 'fully-booked';
      }
    },

    checkEventIsInData: function (uuid) {
      if (this.getEventByUuid(uuid)) {
        this.currentEvent = this.getEventByUuid(uuid);
        this.checkAvailability();
      } else {
        this.$router.push({ name: 'Events' });
      }
    }
  },

  mounted: function () {
    let proxy = this;
    this.eventUuid = this.$route.params.uuid;
    // this.mainImage = document.getElementsByClassName("main-image")
    this.promises.events.promise.then(function () {
      proxy.checkEventIsInData(proxy.eventUuid);
    });
  }

};



// WEBPACK FOOTER //
// ./src/apps/booking/components/events/eventDetail/EventDetail.js